'use client';

import { configKeepDataInfiniy } from '@/config/useQuery';
import { nameof } from '@/lib/utils';
import { FieldResponse } from '@/server/api/v1/field/type';
import { FilterBuilders } from '@/server/base/base-trpc-service';
import { api } from '@/trpc/client';
import { SortValue } from '@/types/enum';
import { BaseQueryCustom } from '@/types/interface';

interface UseQueryProps extends BaseQueryCustom<FieldResponse> {}

/**Lấy lên các nhóm quyền hiện tại của phần mềm */
export const useQueryField = <T extends {} = FieldResponse>(
    props?: UseQueryProps
) => {
    const { enabled = true, filters, mapping } = props || {};
    let extFilters: FilterBuilders<FieldResponse>[] = [];

    const { data, isLoading, isFetching } = api.field.Search.useQuery(
        {
            limit: 100,
            countMaxTo: 100,
            sorts: [
                {
                    key: nameof<FieldResponse>('Name'),
                    value: SortValue.DESC,
                },
            ],
            filters: [...(extFilters ?? []), ...(filters || [])],
        },
        {
            enabled,
            ...configKeepDataInfiniy, // only clear when reload we
        }
    );

    let mappedData: T[] | undefined = undefined;

    if (data?.isSuccessStatus && data.data?.Items) {
        mappedData = [...data.data.Items] as T[];
        if (mapping) {
            mappedData = mappedData.map(mapping) as T[];
        }
    }

    return {
        data: mappedData,
        isLoading,
        isFetching,
    };
};
